import Axios from "axios";
import { loadCss, loadModules, setDefaultOptions } from "esri-loader";
import { Utils } from "./Utils";
import ArrowLineLayer from "./widgets/ArrowLine/ArrowLineLayer";
import { ChengDiLayer } from "./widgets/ChengDi/ChengDiLayer";
import { Cluster } from "./widgets/Cluster/arcgis/Cluster";
import { XMLLayer } from "./widgets/CustomLayer/arcgis/XMLLayer";
// import { DgeneFusion } from "./widgets/DgeneFusion/arcgis/DgeneFusion";
import DirectionModel_ArcGIS from "./widgets/Direction/Model/DirectionModel_ArcGIS";
import DirectionModel_Collinear from "./widgets/Direction/Model/DirectionModel_Collinear";
import { DrawLayer } from "./widgets/DrawLayer/arcgis/DrawLayer";
import { DrawOverlays } from "./widgets/DrawOverlays/arcgis/DrawOverlays";
import DynamicIssuesect from "./widgets/DynamicIssuesect";
import { FindFeature } from "./widgets/FindFeature/arcgis/FindFeature";
import { FindFeatureYp } from "./widgets/FindFeature/arcgis/FindFeature1";

import { GeometrySearch } from "./widgets/GeometrySearch/arcgis/GeometrySearch";
import { LayerSearch } from "./widgets/GeometrySearch/arcgis/LayerSearch";
import HeatImageGL from "./widgets/HeatMap/arcgis/HeatImageGL";
import { HeatMap } from "./widgets/HeatMap/arcgis/HeatMap";
import ImageOverlays from "./widgets/HeatMap/arcgis/ImageOverlays";
import { QueryIntersect } from "./widgets/Intersect/arcgis/QueryIntersect";
import { LayerDefinition } from "./widgets/LayerDefinition/arcgis/LayerDefinition";
import { checkPoints } from "./widgets/MapCenterCheck/arcgis/CheckPoints";
import MapCenterCheck from "./widgets/MapCenterCheck/arcgis/MapCenterCheck";
import MeasureModel_ArcGIS from "./widgets/Measurement/Model/MeasureModel_ArcGIS";
import { Bar3DChart } from "./widgets/MigrateChart/arcgis/Bar3DChart";
import { MigrateChart } from "./widgets/MigrateChart/arcgis/MigrateChart";
import { SubwayLine } from "./widgets/MigrateChart/arcgis/SubwayLine";
import { ComponentOverlay } from "./widgets/Overlays/arcgis/ComponentOverlay";
import ToolTip from "./widgets/Overlays/arcgis/ToolTip";
import SignalPhaseController2D from "./widgets/SignalPhase/2D/SignalPhaseController2D";
import SimulationController from "./widgets/SumoSimulation/SimulationController";
import TrackInCross from "./widgets/TrackLine/arcgis/TrackInCross";
import TrackLine from "./widgets/TrackLine/arcgis/TrackLine";
import TrackPlay from "./widgets/TrackPlay/arcgis/TrackPlay";
import WidgetsManager from "./widgets/WidgetsManager/arcgis/WidgetsManager";
import { ZoomArc2D } from "./widgets/MapControls/arcgis/Zoom";
import { ScaleBarArc2D } from "./widgets/MapControls/arcgis/ScaleBar";
import { OverlayArcgis2D } from "@/plugin/gis-viewer/widgets/Overlays/arcgis/OverlayArcgis2D";

import { OverlayArcgis2DZHZXs } from "@/plugin/gis-viewer/widgets/Overlays/arcgis/OverlayArcgis2DZHZX";

import SelectRoute2D from "@/plugin/gis-viewer/widgets/SelectRoute/arcgis/SelectRoute2D";
import Route from "@/plugin/gis-viewer/widgets/Route/arcgis/Route";
import { ICenterLevel, IComponentOverlayParam, ICrossInView, ICustomTip, IDefinitionParameter, IDrawOverlays, IDynamicLayerDataParams, IFindParameter, IGeometrySearchParameter, IHeatImageParameter, IHeatParameter, ILaneSignalPhaseInfo, ILayerConfig, IMapLevel, IMultiStartRoute, IOverlayClusterParameter, IOverlayDelete, IOverlayParameter, IPointGeometry, IPopUpTemplate, IQueryParameter, IResult, IRouteHitTestParam, IRouteHitTestResultParam, ISelectRouteHitTest, ISelectRouteParam, ISelectRouteResult, ISignalPhaseInfo, IStreetParameter, ISumoConnectInfo, ITrackCross, ITrackLineParameter, ITrackParameter, IWidget, IRouteParameter, IMapControlParam, IHeatMapParams, IAnimateLineDelParams, IAnimateLineAddParams } from "@/types/map";
import AnimateLine from "./widgets/Animation2D/arcgis/AnimateLine";
import { MigrateChartCom } from "./widgets/MigrateChart/arcgis/MigrateChart_common";

export default class MapAppArcGIS2D {
    public view!: __esri.MapView;

    /** 触发后向父组件传参的函数 */
    public showGisDeviceInfo!: (type: string, id: string, detail: any, label?: string) => void;
    public doubleMarkerClick!: (type: string, id: string, detail: any, label?: string) => void;
    public mouseGisDeviceInfo!: (event: any, type: string, id: string, detail: any) => void;
    public mapZoom!: (zoom: { new: number; old: number }) => void;
    public mapBoundary!: (mapB: { topLeft: any; bottomRight: number }) => void;

    public mouseoverlay: any = undefined;
    public mapClick!: (point: object) => void;
    public selectRouteFinished!: (routeInfo: object) => void;
    public intoSignal!: (signalId: string) => void;
    public outofSignal!: (signalId: string) => void;
    public mapInteractive!: (viewPoint: __esri.Viewpoint) => void;
    public topLeft: any = undefined;
    public bottomRight: any = undefined;

    public layerLoaded: any;

    public showFlow: boolean = false;
    public showArrow: boolean = false;
    private tolerance: number = 3;
    private HighlightLayer!: __esri.GraphicsLayer;
    private clickPopup!: {
        label: string;
        popup: any;
        graphic: any;
        mapPoint: any;
    };
    private toolTip!: any;
    private showSubOD: boolean = false;

    private Point!: __esri.PointConstructor;
    private projection: any;
    public measurementTool?: __esri.Measurement;
    public async initialize(gisConfig: any, mapContainer: string): Promise<void> {
        //路由跳转是delete mapConfig属性导致报错
        let mapConfig = Utils.copyObject(gisConfig);
        const gisServer = mapConfig.gisServer;
        const apiUrl = mapConfig.arcgis_api || mapConfig.apiUrl || mapConfig.api_url || "https://js.arcgis.com/4.18";
        setDefaultOptions({
            url: `${apiUrl}/init.js`,
        });
        const cssFile: string = mapConfig.theme ? `themes/${mapConfig.theme}/main.css` : "css/main.css";
        loadCss(`${apiUrl}/esri/${cssFile}`);
        if (mapConfig.theme == "custom") {
            const customcssFile: string = mapConfig.theme ? `themes/${mapConfig.theme}/custom.css` : "";
            if (customcssFile !== "") {
                loadCss(`${apiUrl}/esri/${customcssFile}`);
            }
        }
        let token = "";
        if (mapConfig.token) {
            let tokenConfig = mapConfig.token;
            if (tokenConfig.needToken) {
                token = await this.getToken({
                    url: tokenConfig.tokenUrl,
                    username: tokenConfig.username,
                    password: tokenConfig.password,
                    clientid: tokenConfig.clientid,
                    expiration: tokenConfig.expiration,
                });
            }
        }
        type MapModules = [typeof import("esri/views/MapView"), typeof import("esri/Basemap"), typeof import("esri/Map"), typeof import("esri/request"), typeof import("esri/core/Accessor"), typeof import("esri/Graphic"), typeof import("esri/layers/TileLayer"), typeof import("esri/layers/BaseTileLayer"), typeof import("esri/layers/VectorTileLayer"), typeof import("esri/layers/WebTileLayer"), typeof import("esri/layers/GraphicsLayer"), typeof import("esri/layers/MapImageLayer"), typeof import("esri/layers/FeatureLayer"), typeof import("esri/core/Collection"), typeof import("esri/config"), typeof import("esri/identity/IdentityManager"), typeof import("esri/geometry/Point"), typeof import("esri/geometry/projection"), typeof import("esri/layers/WMTSLayer"), typeof import("esri/webscene/background/Background"), typeof import("esri/WebMap"), typeof import("esri/symbols/TextSymbol")];
        const [MapView, Basemap, Map, esriRequest, Accessor, Graphic, TileLayer, BaseTileLayer, VectorTileLayer, WebTileLayer, GraphicsLayer, MapImageLayer, FeatureLayer, Collection, esriConfig, IdentityManager, Point, projection, WMTSLayer, Background, WebMap, TextSymbol] = await(loadModules(["esri/views/MapView", "esri/Basemap", "esri/Map", "esri/request", "esri/core/Accessor", "esri/Graphic", "esri/layers/TileLayer", "esri/layers/BaseTileLayer", "esri/layers/VectorTileLayer", "esri/layers/WebTileLayer", "esri/layers/GraphicsLayer", "esri/layers/MapImageLayer", "esri/layers/FeatureLayer", "esri/core/Collection", "esri/config", "esri/identity/IdentityManager", "esri/geometry/Point", "esri/geometry/projection", "esri/layers/WMTSLayer", "esri/webscene/background/Background", "esri/WebMap", "esri/symbols/TextSymbol"]) as Promise<MapModules>);
        this.Point = Point;
        this.projection = projection;

        esriConfig.fontsUrl = apiUrl + "/font/";

        let baseLayers: __esri.Collection = new Collection();
        if (mapConfig.baseLayers) {
            baseLayers.addMany(
                mapConfig.baseLayers.map((layerConfig: ILayerConfig) => {
                    if (layerConfig.url) {
                        layerConfig.url = layerConfig.url.replace(/{gisserver}/i, gisServer);
                    }
                    if (layerConfig.type === "tiled") {
                        delete layerConfig.type;
                        return new TileLayer(layerConfig);
                    } else if (layerConfig.type === "webtiled") {
                        delete layerConfig.type;
                        let layer = new WebTileLayer({
                            urlTemplate: layerConfig.url,
                            subDomains: layerConfig.subDomains || undefined,
                            label: layerConfig.label,
                            ...layerConfig,
                        } as any);
                        if (mapConfig.options.constraints && mapConfig.options.constraints.lods) {
                            layer.tileInfo.lods = mapConfig.options.constraints.lods;
                        }
                        return layer;
                    } else if (layerConfig.type === "dynamic") {
                        delete layerConfig.type;
                        if ((layerConfig as any).showFlow) {
                            this.showFlow = true;
                        }
                        return new MapImageLayer(layerConfig);
                    } else if (layerConfig.type === "feature") {
                        delete layerConfig.type;
                        return new FeatureLayer(layerConfig);
                    } else if (layerConfig.type === "WMTS") {
                        return new WMTSLayer({
                            url: layerConfig.url,
                        });
                    } else if (layerConfig.type === "vector") {
                        //矢量切片地图服务
                        delete layerConfig.type;
                        return new VectorTileLayer(layerConfig);
                    } else if (layerConfig.type === "baseTileLayer") {
                        //nginx服务器地图切片
                        delete layerConfig.type;
                        let arcgisTileLayer = (BaseTileLayer as any).createSubclass({
                            properties: {
                                urlTemplate: null,
                            },
                            getTileUrl: function (level: any, row: any, col: any) {
                                return layerConfig.url + "L" + zeroPad(level, 2, 10) + "/" + "R" + zeroPad(row, 8, 16) + "/" + "C" + zeroPad(col, 8, 16) + "." + "png";
                            },
                        });
                        function zeroPad(num: any, len: any, radix: any) {
                            let str = num.toString(radix || 10);
                            while (str.length < len) {
                                str = "0" + str;
                            }
                            return str;
                        }
                        return new arcgisTileLayer();
                    } else if (layerConfig.type === "baseTileLayerCustomRA") {
                        //如安geowebcache-wmts地图服务
                        delete layerConfig.type;
                        let tileLayerCustomRA = (BaseTileLayer as any).createSubclass({
                            properties: {
                                urlTemplate: layerConfig.url,
                            },
                            getTileUrl: function (level: any, row: any, col: any) {
                                return this.urlTemplate.replace("{level}", String(level)).replace("{col}", String(col)).replace("{row}", String(row));
                            },
                        });
                        return new tileLayerCustomRA({
                            urlTemplate: layerConfig.url,
                            ...layerConfig,
                        });
                    }
                })
            );
        }
        if (mapConfig.token && mapConfig.token.needToken) {
            IdentityManager.registerToken({
                server: mapConfig.token.server,
                token: token,
            });
        }

        //this.destroy();
        let basemap: __esri.Basemap = new Basemap({
            baseLayers,
        });
        let map = new Map({ basemap });

        const view: __esri.MapView = new MapView({
            map: map,
            container: mapContainer,
            ...mapConfig.options,
        });

        view.ui.remove(["attribution", "compass", "zoom"]);
        (view as any).mapConfig = mapConfig;
        (view as any).mapOptions = mapConfig.options;

        if (mapConfig.operationallayers) {
            await this.createLayer(view, mapConfig.operationallayers, gisServer);
        }

        if (mapConfig.widgets) {
            await this.showWidgetTools(view, mapConfig.widgets);
        }

        let _this = this;

        view.popup.watch("visible,selectedFeature", async newValue => {
            if (newValue) {
                let content: any = view.popup.content;
                if (view.popup.selectedFeature) {
                    let layer: any = view.popup.selectedFeature.layer;
                    //feature
                    var attributes = view.popup.selectedFeature.attributes;
                    for (let field in attributes) {
                        if (field.indexOf("状态") > -1) {
                            attributes[field] = attributes[field].replace("1", "舒适");
                            attributes[field] = attributes[field].replace("2", "拥挤");
                            attributes[field] = attributes[field].replace("3", "故障");
                        }
                        if (field.indexOf("FSTR_CFMSTATE") > -1) {
                            attributes[field] = attributes[field].replace("free", "畅通");
                            attributes[field] = attributes[field].replace("crowd", "拥堵");
                            attributes[field] = attributes[field].replace("jam", "堵塞");
                        }
                        let fieldArr: string[] = field.toString().split(".");
                        let newfield = fieldArr.pop() as string;
                        if (!attributes.hasOwnProperty(newfield)) {
                            attributes[newfield] = attributes[field] !== undefined && attributes[field] !== null ? attributes[field].toString().replace("Null", "") : "";
                        }
                    }
                    if (layer.popupTemplate && layer.popupTemplate.content && typeof layer.popupTemplate.content == "string") {
                        //重新获取弹窗popupTemplate.content
                        let layOpt = mapConfig.operationallayers.find((opt: any) => {
                            if (opt.label == layer.label && opt.url == layer.url + "/" + layer.layerId) {
                                return true;
                            }
                        });
                        if (layOpt) {
                            layer.popupTemplate.content = _this.getContent(attributes, layOpt.popupTemplate.content);
                        }
                    }
                } else {
                    //dynamic
                    if (typeof content === "string") {
                        content = content.replace("free", "畅通").replace("unknown", "畅通").replace("crowd", "拥堵").replace("jam", "堵塞");
                        if (content.toString().indexOf("Null") > -1) {
                            content = content.toString().replace(/Null/g, "");
                        }
                        view.popup.content = content;
                    }
                }
                if (content == "Null" || content == "" || content == null) {
                    view.popup.close();
                }
            }
        });
        view.when(() => {
            // 获取可视范围的边界坐标
            let visibleExtent = view.extent;
            this.topLeft = new this.Point({ x: visibleExtent.xmin, y: visibleExtent.ymin, spatialReference: view.spatialReference });
            this.bottomRight = new this.Point({ x: visibleExtent.xmax, y: visibleExtent.ymax, spatialReference: view.spatialReference });
            view.watch("extent", (event: any) => {
                // 获取可视范围的边界坐标
                let visibleExtent = event.extent;
                this.topLeft = new this.Point({ x: visibleExtent.xmin, y: visibleExtent.ymin, spatialReference: view.spatialReference });
                this.bottomRight = new this.Point({ x: visibleExtent.xmax, y: visibleExtent.ymax, spatialReference: view.spatialReference });
                this.mapBoundary({ topLeft: this.topLeft, bottomRight: this.bottomRight });
                // 过滤坐标数据，只保留位于可视范围内的坐标
            });
            setTimeout(() => {
                this.mapBoundary({ topLeft: this.topLeft, bottomRight: this.bottomRight });
            }, 1000);
        });

        view.on(["pointer-move"], async (event: any) => {
            const response = await view.hitTest(event);
            if (response.results?.length > 0) {
                let result = response.results[0];

                const graphic = result.graphic;
                if (!graphic.attributes) {
                    graphic.attributes = {};
                }
                let { type, id } = graphic.attributes;
                let label = graphic.layer ? (graphic.layer as any).label : "";
                if (graphic.layer && (graphic.layer.type == "feature" || graphic.layer.type == "graphics")) {
                    id = graphic.attributes["DEVICEID"] || graphic.attributes["FEATUREID"] || graphic.attributes["SECTIONID"] || graphic.attributes["id"] || graphic.attributes["ID"] || undefined;
                    type = graphic.attributes["DEVICETYPE"] || graphic.attributes["FEATURETYPE"] || graphic.attributes["FEATURETYP"] || graphic.attributes["type"] || graphic.attributes["TYPE"] || label || undefined;
                }
                //if (id) {
                // if (
                //   graphic.attributes &&
                //   (graphic.attributes.isCluster || graphic.attributes.isClusterText)
                // ) {
                //   return;
                // }
                if (graphic.layer && (graphic.layer as any).toolTipContent) {
                    this.moveToolTip(graphic, (graphic.layer as any).toolTipContent.content);
                }
                if (graphic.geometry.type === "point") {
                    const screenPoint = this.view.toScreen(graphic.geometry as __esri.Point);
                    event.screenPoint = screenPoint;
                }
                if (!this.mouseoverlay) {
                    event.type = "mouseover";

                    this.mouseGisDeviceInfo(event, type, id, graphic);
                    this.mouseoverlay = {
                        event,
                        type,
                        id,
                        graphic: graphic,
                    };
                } else {
                    // console.log("aaaa", this.mouseoverlay);
                    if (this.mouseoverlay && (this.mouseoverlay.id !== id || this.mouseoverlay.type !== type || JSON.stringify(this.mouseoverlay.graphic.attributes) != JSON.stringify(graphic.attributes))) {
                        if (this.toolTip) {
                            this.toolTip.remove();
                            this.toolTip = null;
                        }
                        event.type = "mouseout";
                        this.mouseGisDeviceInfo(event, this.mouseoverlay.type, this.mouseoverlay.id, this.mouseoverlay.graphic);
                        this.mouseoverlay = undefined;
                    }
                }
            } else {
                if (this.mouseoverlay) {
                    if (this.toolTip) {
                        this.toolTip.remove();
                        this.toolTip = null;
                    }
                    event.type = "mouseout";
                    this.mouseGisDeviceInfo(event, this.mouseoverlay.type, this.mouseoverlay.id, this.mouseoverlay.graphic);
                    this.mouseoverlay = undefined;
                }
            }
        });
        view.on("click", async event => {
            // let childList = event.native.target;
            // console.log(childList, view, event.native);
            if (event.mapPoint) {
                let mp = event.mapPoint;
                if (!mp.spatialReference.isWGS84 && !mp.spatialReference.isWebMercator) {
                    //城建坐标
                    this.mapClick({
                        x: mp.x,
                        y: mp.y,
                        lnt: mp.longitude,
                        lat: mp.latitude,
                        wkid: mp.spatialReference.wkid,
                    });
                } else {
                    this.mapClick({
                        x: mp.longitude,
                        y: mp.latitude,
                        lnt: mp.longitude,
                        lat: mp.latitude,
                        realx: mp.x,
                        realy: mp.y,
                        wkid: mp.spatialReference.wkid,
                    });
                }
            } else {
                this.mapClick(event);
            }
            this.hideBarChart();
            this.showSubwayChart();
            if (this.HighlightLayer) {
                this.HighlightLayer.removeAll();
            }
            const response = await view.hitTest(event);
            console.log(response);

            //过滤掉覆盖在图层上用于高亮的要素(重复点击正在高亮的要素时)
            if (response.results?.length > 0 && response.results[0].graphic?.attributes?.id == "highlight") {
                // this.stopHighlightFeature();//不能在这里停止高亮
                response.results.splice(0, 1);
            }
            if (response.results?.length > 0 && (response.results[0].graphic as any).isclick !== false && ((response.results[0].graphic as any).layer === null || (response.results[0].graphic as any).layer === undefined || ((response.results[0].graphic as any).layer && (response.results[0].graphic as any).layer.isclick !== false))) {
                let result = response.results[0];
                const graphic = result.graphic;
                if (!graphic.attributes) {
                    return;
                }
                let { type, id } = graphic.attributes;
                let label = graphic.layer ? (graphic.layer as any).label : "";
                if (graphic.layer && (graphic.layer.type == "feature" || graphic.layer.type == "graphics")) {
                    id = graphic.attributes["DEVICEID"] || graphic.attributes["FEATUREID"] || graphic.attributes["SECTIONID"] || graphic.attributes["id"] || graphic.attributes["ID"] || undefined;
                    type = graphic.attributes["DEVICETYPE"] || graphic.attributes["FEATURETYPE"] || graphic.attributes["FEATURETYP"] || graphic.attributes["type"] || graphic.attributes["TYPE"] || label || undefined;
                }

                if (graphic.attributes && (graphic.attributes.isCluster || graphic.attributes.isClusterText)) {
                    label = "cluster";
                }

                this.clickPopup = {
                    label: label,
                    popup: graphic.layer ? (graphic.layer as any).popupTemplate : undefined,
                    graphic: graphic,
                    mapPoint: event.mapPoint,
                };
                (graphic as any).mapPoint = event.mapPoint;
                (graphic as any).screenPoint = event.screenPoint;
                this.showGisDeviceInfo(type, id, graphic, label);
                this.showSubBar(graphic.layer, event.mapPoint, graphic);
                this.showSubwayChart(graphic.layer, graphic);
                if (graphic.layer && (graphic.layer as any).ishighlight) {
                    this.highlightFeature(graphic.geometry);
                }
            } else {
                this.doIdentifyTask(event.mapPoint).then((results: any) => {
                    if (results?.length > 0) {
                        let res = results.filter((item: any) => {
                            if (item != undefined) {
                                return true;
                            } else {
                                return false;
                            }
                        })[0];
                        if (!res) {
                            return;
                        }
                        let layername = res.layerName;
                        let layerid = res.layerId;
                        let id = res.feature.attributes["DEVICEID"] || res.feature.attributes["FEATUREID"] || res.feature.attributes["SECTIONID"] || res.feature.attributes[res.displayFieldName];
                        //res.feature.attributes.geometry = res.feature.geometry;

                        this.highlightFeature(res.feature.geometry);
                        let selectLayer = this.getLayerByName(layername, layerid);
                        if (selectLayer && selectLayer.popupTemplates) {
                            this.showSubBar(selectLayer, event.mapPoint, res.feature);
                            let popup = selectLayer.popupTemplates[layerid];
                            this.clickPopup = {
                                label: layername,
                                popup: popup,
                                graphic: res.feature,
                                mapPoint: event.mapPoint,
                            };
                            if (popup && selectLayer.popupEnabled !== false) {
                                this.view.popup.open({
                                    title: popup.title,
                                    content: this.getContent(res.feature.attributes, popup.content),
                                    location: event.mapPoint,
                                });
                            }
                        }
                        res.feature.mapPoint = event.mapPoint;
                        res.feature.screenPoint = event.screenPoint;
                        this.showGisDeviceInfo(layername, id, res.feature, selectLayer ? selectLayer.label : layername);
                    } else {
                        ToolTip.clear(this.view, undefined, "custom-popup");
                    }
                });
            }
        });
        // view.on("drag", event => {
        //   console.log("移动事件", event);
        //   // 获取操作图层的范围
        //   // let mp = event.mapPoint;
        //   // console.log(event, 2221);
        //   //   this.showExtent(event);
        // });
        view.popup.on("trigger-action", event => {
            console.log(event, "点击了");
            const graphic = view.popup.selectedFeature;
            if (event.action.id === "sumo-details") {
                this.showGisDeviceInfo("sumo-details", graphic.attributes["id"], graphic);
                view.popup.close();
            }
        });
        view.on("double-click", async event => {
            console.log(event, "点击了123");
            const response = await view.hitTest(event);
            event.stopPropagation();
            console.log(response);
            if (response.results?.length > 0 && (response.results[0].graphic as any).isclick !== false && ((response.results[0].graphic as any).layer === null || (response.results[0].graphic as any).layer === undefined || ((response.results[0].graphic as any).layer && (response.results[0].graphic as any).layer.isclick !== false))) {
                let result = response.results[0];
                const graphic = result.graphic;
                if (!graphic.attributes) {
                    return;
                }
                let { type, id } = graphic.attributes;
                let label = graphic.layer ? (graphic.layer as any).label : "";
                if (graphic.layer && (graphic.layer.type == "feature" || graphic.layer.type == "graphics")) {
                    id = graphic.attributes["DEVICEID"] || graphic.attributes["FEATUREID"] || graphic.attributes["SECTIONID"] || graphic.attributes["id"] || graphic.attributes["ID"] || undefined;
                    type = graphic.attributes["DEVICETYPE"] || graphic.attributes["FEATURETYPE"] || graphic.attributes["FEATURETYP"] || graphic.attributes["type"] || graphic.attributes["TYPE"] || label || undefined;
                }

                if (graphic.attributes && (graphic.attributes.isCluster || graphic.attributes.isClusterText)) {
                    label = "cluster";
                }

                this.clickPopup = {
                    label: label,
                    popup: graphic.layer ? (graphic.layer as any).popupTemplate : undefined,
                    graphic: graphic,
                    mapPoint: event.mapPoint,
                };
                (graphic as any).mapPoint = event.mapPoint;
                (graphic as any).screenPoint = event.screenPoint;
                this.doubleMarkerClick(type, id, graphic, label);
            }
        });
        // view.on("viewpoint-change", (event: any) => {
        //   var extent = view.extent;
        //   // 创建查询对象
        //   var query = clusterLayer.createQuery();
        //   query.geometry = extent; // 设置查询的几何范围为当前视图范围

        //   clusterLayer
        //     .queryFeatures(query)
        //     .then(function (results: any) {
        //       console.log("处理了吗", results);

        //       // 处理查询结果，例如更新图层的数据或渲染
        //       // 示例代码：
        //       // 清空现有数据
        //       clusterLayer.removeAll();

        //       // 添加查询结果到图层
        //       clusterLayer.addMany(results.features);
        //     })
        //     .catch(function (error: any) {
        //       console.error("查询错误：", error);
        //     });
        // });
        await view.when();
        this.view = view;

        view.watch("zoom", async (newValue, oldValue) => {
            this.mapZoom({ new: newValue, old: oldValue });
        });

        if (mapConfig.options && mapConfig.options.tolerance) {
            this.tolerance = mapConfig.options && mapConfig.options.tolerance;
        }
        (this.view.popup as any).visibleElements = {
            featureNavigation: false,
            closeButton: false,
        };

        this.setZoomCtrl(mapConfig.options?.zoomControl);
        this.setScaleBar(mapConfig.options?.scaleBar);
    }
    public async showExtent(event: any) {
        let mp = event.mapPoint;

        // type MapModules = [typeof import('esri/geometry/Extent'), typeof import('esri/geometry/SpatialReference')];
        // const [geometryExtent, SpatialReference] = await (loadModules(['esri/geometry/Extent', 'esri/geometry/SpatialReference']) as Promise<MapModules>);
        // let MaxfullExtent = {
        //     xmin: 121.1333397488253,
        //     ymin: 31.47715074023192,
        //     xmax: 121.93603253841007,
        //     ymax: 30.868870975845127,
        // };
        // let ext = this.view.extent;
        // if (ext.xmin < MaxfullExtent.xmin || ext.xmax > MaxfullExtent.xmax || ext.ymax > MaxfullExtent.ymax || ext.ymin < MaxfullExtent.ymin) {
        //     this.view.goTo({
        //         center: [121.51840714655606, 31.22393053137967],
        //     });
        // }
    }
    private async moveToolTip(graphic: any, content: string) {
        if (this.toolTip) {
            this.toolTip.remove();
            this.toolTip = null;
        }
        this.toolTip = new ToolTip(
            this.view,
            {
                title: "",
                istip: true,
                yoffset: 40,
                content: this.getContent(graphic.attributes, content),
            },
            graphic
        );
    }

    private async getToken(tokenConfig: any): Promise<any> {
        let username = tokenConfig.username;
        let password = tokenConfig.password;
        let clientid = "ref.http://" + window.location.host;
        let expiration = tokenConfig.expiration;
        let url = tokenConfig.url + `/RemoteTokenServer?request=getToken&username=${username}&password=${password}&clientid=${clientid}&expiration=${expiration}`;
        return new Promise((resolve: any, reject: any) => {
            Axios.get(url)
                .then((result: any) => {
                    let token = result.data;
                    token = token.substr(0, token.length - 2);
                    console.log(token);
                    // document.cookie =
                    //   "agstoken=" +
                    //   token +
                    //   ";path=http://c-map.gtj.sh.cegn.cn:8098/OneMapServer/";
                    resolve(token);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }
    private showSubBar(layer: any, point: any, feature: any) {
        if (layer && layer.showBar) {
            this.view.popup.alignment = "bottom-center";
            let inField;
            let outField;
            if (layer.barFields) {
                inField = layer.barFields.inField;
                outField = layer.barFields.outField;
            }
            this.showBarChart({
                points: [
                    {
                        geometry: {
                            x: point.x,
                            y: point.y,
                            spatialReference: this.view.spatialReference,
                        },
                        fields: {
                            inflow: feature.attributes[inField] || feature.attributes["IN_FLX_NR"] || feature.attributes["VOLUME_YESTERDAY"] || feature.attributes["YJZH.STAT_METROLINEFLOW.VOLUME_YESTERDAY"],
                            outflow: feature.attributes[outField] || feature.attributes["OUT_FLX_NR"] || feature.attributes["VOLUME_TODAY"] || feature.attributes["YJZH.STAT_METROLINEFLOW.VOLUME_TODAY"],
                        },
                    },
                ],
                name: "地铁线路图",
            });
        } else {
            this.view.popup.alignment = "top-center";
        }
    }
    private showSubwayChart(layer?: any, feature?: any) {
        if (layer && layer.showMigrate) {
            let attr = feature.attributes;
            let id = "";
            for (let field in attr) {
                if (field.indexOf("FEATUREID") > -1 || field.indexOf("DEVICEID") > -1 || field.indexOf("SECTIONID") > -1) {
                    id = attr[field].toString();
                }
            }
            this.showSubOD = true;
            this.showODChart({
                id: id,
                type: layer.odtype || "d",
                label: layer.label,
                url: layer.url + "/" + layer.layerId,
            });
        } else {
            if (this.showSubOD) {
                this.showODChart(undefined);
            }
        }
    }
    private destroy() {}
    //使toolTip中支持{字段}的形式
    private getContent(attr: any, content: string): string {
        let tipContent = content;
        if (content) {
            //键值对
            for (let fieldName in attr) {
                if (attr.hasOwnProperty(fieldName)) {
                    tipContent = tipContent.replace("{" + fieldName + "}", attr[fieldName]);
                }
            }
        }
        let reg = / \{.*?\}/g;
        tipContent = tipContent.replace(reg, "");
        return tipContent;
    }
    private getLayerIds(layer: any): any[] {
        let layerids = [];
        if (layer.type == "feature") {
            //featurelayer查询
            layerids.push(layer.layerId);
        } else if (layer.type == "map-image") {
            let sublayers = (layer as __esri.MapImageLayer).sublayers;
            sublayers.forEach(sublayer => {
                if (sublayer.visible) {
                    layerids.push(sublayer.id);
                }
            });
        }
        return layerids.reverse();
    }
    private getLayerByName(layername: string, id: string): any {
        let selLayer;
        this.view.map.allLayers.toArray().forEach((layer: any) => {
            if (layer.type == "imagery" || layer.type == "map-image") {
                let sublayers = (layer as __esri.MapImageLayer).allSublayers;
                sublayers.forEach(sublayer => {
                    if (sublayer.title == layername && sublayer.id.toString() == id) {
                        selLayer = layer;
                    }
                });
            }
        });
        return selLayer;
    }
    private async doIdentifyTask(clickpoint: any) {
        let layers = this.view.map.allLayers.filter((layer: any) => {
            if (layer.visible && (layer.type == "imagery" || layer.type == "map-image")) {
                return true;
            }
            return false;
        });
        let that = this;
        type MapModules = [typeof import("esri/Graphic"), typeof import("esri/tasks/IdentifyTask"), typeof import("esri/tasks/support/IdentifyParameters")];
        const [Graphic, IdentifyTask, IdentifyParameters] = await (loadModules(["esri/Graphic", "esri/tasks/IdentifyTask", "esri/tasks/support/IdentifyParameters"]) as Promise<MapModules>);
        let promises: any = layers.toArray().map((layer: any) => {
            return new Promise((resolve, reject) => {
                let identify = new IdentifyTask(layer.url); //创建属性查询对象
                let identifyParams = new IdentifyParameters(); //创建属性查询参数
                identifyParams.tolerance = this.tolerance;
                identifyParams.layerIds = that.getLayerIds(layer);
                identifyParams.layerOption = "visible"; //"top"|"visible"|"all"
                identifyParams.width = that.view.width;
                identifyParams.height = that.view.height;
                identifyParams.geometry = clickpoint;
                identifyParams.returnGeometry = true;
                identifyParams.mapExtent = that.view.extent;

                // 执行查询对象
                identify.execute(identifyParams).then((data: any) => {
                    let results = data.results;
                    if (results?.length < 1) {
                        resolve(undefined);
                    } else {
                        resolve(results[0]);
                    }
                });
            });
        });
        return new Promise(resolve => {
            Promise.all(promises).then((e: any) => {
                resolve(e);
            });
        });
    }
    private async createLayer(view: __esri.MapView, layers: any, gisServer: string) {
        type MapModules = [typeof import("esri/layers/FeatureLayer"), typeof import("esri/layers/GraphicsLayer"), typeof import("esri/layers/WebTileLayer"), typeof import("esri/layers/MapImageLayer"), typeof import("esri/layers/GeoJSONLayer"), typeof import("esri/layers/KMLLayer"), typeof import("esri/layers/WMSLayer"), typeof import("esri/core/watchUtils"), typeof import("esri/layers/TileLayer"), typeof import("esri/layers/BaseTileLayer"), typeof import("esri/layers/VectorTileLayer"), typeof import("esri/layers/GroupLayer"), typeof import("esri/Color")];
        const [FeatureLayer, GraphicsLayer, WebTileLayer, MapImageLayer, GeoJSONLayer, KMLLayer, WMSLayer, watchUtils, TileLayer, BaseTileLayer, VectorTileLayer, GroupLayer, Color] = await (loadModules(["esri/layers/FeatureLayer", "esri/layers/GraphicsLayer", "esri/layers/WebTileLayer", "esri/layers/MapImageLayer", "esri/layers/GeoJSONLayer", "esri/layers/KMLLayer", "esri/layers/WMSLayer", "esri/core/watchUtils", "esri/layers/TileLayer", "esri/layers/BaseTileLayer", "esri/layers/VectorTileLayer", "esri/layers/GroupLayer", "esri/Color"]) as Promise<MapModules>);
        let map = view.map;
        let _this = this;

        map.addMany(
            layers
                .map((layerConfig: any, index: number) => {
                    let layer: any;
                    let type = layerConfig.type.toLowerCase();
                    if (layerConfig.url) {
                        layerConfig.url = layerConfig.url.replace(/{gisserver}/i, gisServer);
                    }
                    delete layerConfig.type;
                    switch (type) {
                        case "group":
                            layerConfig.layers = layerConfig.layers.map((grouplayerConfig: any) => {
                                let glayer;
                                let gtype = grouplayerConfig.type.toLowerCase();
                                delete grouplayerConfig.type;
                                switch (gtype) {
                                    case "tiled":
                                        glayer = new TileLayer(grouplayerConfig);
                                        break;
                                    case "vector":
                                        glayer = new VectorTileLayer(grouplayerConfig);
                                        break;
                                    case "feature":
                                        glayer = new FeatureLayer(grouplayerConfig);
                                        break;
                                }
                                return glayer;
                            });
                            layer = new GroupLayer(layerConfig);
                            break;
                        case "tiled":
                            layer = new TileLayer(layerConfig);
                            break;
                        case "vector":
                            layer = new VectorTileLayer(layerConfig);
                            break;
                        case "baseTileLayer":
                            let arcgisTileLayer = (BaseTileLayer as any).createSubclass({
                                properties: {
                                    urlTemplate: null,
                                },
                                getTileUrl: function (level: any, row: any, col: any) {
                                    return layerConfig.url + "L" + zeroPad(level, 2, 10) + "/" + "R" + zeroPad(row, 8, 16) + "/" + "C" + zeroPad(col, 8, 16) + "." + "png";
                                },
                            });
                            function zeroPad(num: any, len: any, radix: any) {
                                let str = num.toString(radix || 10);
                                while (str.length < len) {
                                    str = "0" + str;
                                }
                                return str;
                            }
                            layer = new arcgisTileLayer();
                            break;
                        case "baseTileLayerCustomRA":
                            let tileLayerCustomRA = (BaseTileLayer as any).createSubclass({
                                properties: {
                                    urlTemplate: layerConfig.url,
                                },
                                getTileUrl: function (level: any, row: any, col: any) {
                                    return this.urlTemplate.replace("{level}", String(level)).replace("{col}", String(col)).replace("{row}", String(row));
                                },
                            });
                            layer = new tileLayerCustomRA({
                                urlTemplate: layerConfig.url,
                                ...layerConfig,
                            });
                            break;
                        case "feature":
                            if ((layerConfig as any).showFlow) {
                                _this.showFlow = true;
                            }
                            if ((layerConfig as any).showArrow) {
                                _this.showArrow = true;
                            }
                            layer = new FeatureLayer(layerConfig);
                            break;
                        case "geojson":
                            layer = new GeoJSONLayer(layerConfig);
                            break;
                        case "xml":
                            layerConfig.layerIndex = index;
                            const xmllayer = XMLLayer.getInstance(view);
                            xmllayer.addXMLLayer(layerConfig);
                            break;
                        case "kml":
                            layer = new KMLLayer(layerConfig);
                            break;
                        case "dynamic":
                            if ((layerConfig as any).showFlow) {
                                _this.showFlow = true;
                            }
                            layer = new MapImageLayer(layerConfig);
                            break;
                        case "wms":
                            layer = new WMSLayer(layerConfig);
                            break;
                        case "webtiled":
                            layer = new WebTileLayer({
                                urlTemplate: layerConfig.url,
                                subDomains: layerConfig.subDomains || undefined,
                                label: layerConfig.label,
                                ...layerConfig,
                            } as any);
                            break;
                        case "chengdi":
                            const cd = ChengDiLayer.getInstance(view);
                            cd.addChengDiLayer(layerConfig);
                            break;
                        case "json":
                            const drawlayer = DrawLayer.getInstance(view);
                            drawlayer.addDrawLayer(layerConfig);
                            break;
                        case "image":
                            this.imageParams.push(layerConfig);
                            // const heat = ImageOverlays.getInstance(view);
                            // heat.addCanvasImage(layerConfig);
                            break;
                    }
                    // if (layer) {
                    //   layer.id = layerConfig.id || layerConfig.label;
                    // }
                    return layer;
                })
                .filter((layer: any) => {
                    return layer !== undefined;
                })
        );
        this.HighlightLayer = new GraphicsLayer();
        view.map.add(this.HighlightLayer);

        // 处理地铁线路和站点图层
        this._setMetroLineAndStation(view);

        watchUtils.whenNotOnce(view, "updating", (n: any, o: any) => {
            if (_this.layerLoaded) {
                _this.layerLoaded();
            }
            if (_this.showFlow) {
                _this.showSubwayFlow();
            }
            if (_this.showArrow) {
                _this.AnimateLine();
            }
        });
    }

    //配置缩放控件
    private async setZoomCtrl(params: any) {
        if (!params || params.visible !== true) {
            return;
        }
        let mapCtrlParams = {
            type: "zoom",
            anchor: params.anchor,
            visible: params.visible,
            options: {
                xoffset: params.offset?.x,
                yoffset: params.offset?.y,
            },
        };
        this.setMapControl(mapCtrlParams);
    }

    //配置比例尺控件
    private async setScaleBar(params: any) {
        if (!params || params.visible !== true) {
            return;
        }
        let mapCtrlParams = {
            type: "scale",
            anchor: params.anchor,
            visible: params.visible,
            options: {
                unit: params.unit,
                xoffset: params.offset?.x,
                yoffset: params.offset?.y,
            },
        };
        this.setMapControl(mapCtrlParams);
    }

    // 单独处理地铁线路和地铁站点图层，以绘制“地铁线路closed”图层
    private async _setMetroLineAndStation(view: any) {
        // 判断是否同时存在地铁线路和站点图层
        let metro_line: any, metro_station: any;
        let index = 0;
        view.map.layers.forEach((layer: any, i: any) => {
            if (layer.label == "metro_line") {
                metro_line = layer;
                index = i;
            }
            if (layer.label == "metro_station") {
                metro_station = layer;
            }
        });
        if (!metro_line || !metro_station) {
            return;
        }
        // console.log("metro_line", metro_line);
        // console.log("metro_station", metro_station);
        const [Graphic, GraphicsLayer, watchUtils] = await loadModules(["esri/Graphic", "esri/layers/GraphicsLayer", "esri/core/watchUtils"]);
        const metro_closed_layer = new GraphicsLayer();
        // 1.拿到每条线路，通过每条线路的线路名称，查询站点图层上的拥堵站点
        const all_line = await metro_line.queryFeatures();
        // 拿到所有站点,并按照线路分类存储
        const all_station = await metro_station.queryFeatures();
        const station_map = new Map<string, Array<any>>();
        // console.log("all_line", all_line.features);
        // console.log("all_station", all_station.features);
        all_station.features.forEach((feature: any) => {
            const _ln = feature.attributes["轨道车站.LINEBELONG"] as string;
            if (!station_map.has(_ln)) {
                station_map.set(_ln, new Array<any>());
            }
            const st_arr = station_map.get(_ln);
            st_arr?.push(feature);
        });
        // console.log("station_map", station_map);
        // 每条线路单独处理
        for (let i = 0; i < all_line.features.length; ++i) {
            const line = all_line.features[i];
            const name = line.attributes["线路名"];
            // const queryParams = metro_station.createQuery();
            // queryParams.where = "LINEBELONG = '" + name + "'";
            // queryParams.geometry = line.geometry;
            // queryParams.distance = 300;
            const closed_line_graphic = new Graphic({
                symbol: {
                    type: "simple-line",
                    color: [255, 0, 0],
                    style: "solid",
                    width: 2,
                },
                geometry: {
                    type: "polyline", // autocasts as new Polyline()
                    paths: new Array<Array<[number, number]>>(),
                },
            });

            if (name == "轨道交通11号线") {
                // console.log("a");
            }

            // 2.线路逐点遍历，判断和拥堵站点的图上距离，如果存在一个拥堵站点与线路上的点距离为0，
            //  则将该点加入绘制图层中，并将后续点同样加入绘制图层中，直到遇到第二个点与线路上的距离为0
            // const res_station = await metro_station.queryFeatures(queryParams);
            const res_station = station_map.get(name) as Array<any>;
            // let isclosedline = false; //用于判断线路上的点是否closed
            line.geometry.paths.forEach((path: any) => {
                const closed_paths = new Array<Array<[number, number]>>();
                let tmp_path = new Array<[number, number]>(); // 线路按照站点分段存储，两个open站点之间的段抛弃
                let last_point_isopen = true; //默认这段第一个站点是open
                // path上逐点判断状态
                path.forEach((p: any) => {
                    tmp_path.push(p);
                    // 计算p与所有站点的距离
                    for (let j = 0; j < res_station?.length; j++) {
                        const s = res_station[j];
                        // 找到了离站点最近的线上点
                        if (Utils.distance([s.geometry.x, s.geometry.y], p) < 5) {
                            if (s.attributes["YJZH.EMG_CONFIG_ZDZT.STATN_STATUS"] == "2") {
                                // if (s.attributes["STATE"] == "open") {
                                // 抛弃这段open路段
                                if (last_point_isopen) {
                                    tmp_path = new Array<[number, number]>();
                                } else {
                                    //这个点是新段的起点，把上一段存储起来
                                    closed_paths.push(tmp_path);
                                }
                                last_point_isopen = true;
                                break;
                                // } else if (s.attributes["STATE"] == "closed") {
                            } else if (s.attributes["YJZH.EMG_CONFIG_ZDZT.STATN_STATUS"] == "1") {
                                last_point_isopen = false;
                                //这个点是新段的起点，把上一段存储起来
                                closed_paths.push(tmp_path);
                                break;
                            }
                        }
                    }
                });
                // 处理尾巴
                if (!last_point_isopen) {
                    closed_paths.push(tmp_path);
                }
                // 将closed路段存入
                closed_paths.forEach((path: any) => {
                    closed_line_graphic.geometry.paths.push(path);
                });
                // if(closed_line_graphic.geometry.paths.length>0){

                // }
            });
            metro_closed_layer.graphics.add(closed_line_graphic);
            // console.log(name, closed_line_graphic.geometry.paths);
            // console.log("before add2", metro_closed_layer.graphics.length);
        }
        // console.log("before add", metro_closed_layer.graphics.length);
        view.map.layers.add(metro_closed_layer, index + 1);
        // 监听 线路图层的显示和隐藏
        metro_closed_layer.visible = metro_line.visible;
        watchUtils.whenTrueOnce(metro_line, "loaded", () => {
            metro_closed_layer.visible = metro_line.visible;
        });
        // console.log("metro_closed_layer", metro_closed_layer);
        watchUtils.watch(metro_line, "visible", (show: any) => {
            metro_closed_layer.visible = show;
        });
    }

    public async AnimateLine() {
        const flow = ArrowLineLayer.getInstance(this.view);
        flow.initialize();
    }

    public async clearArrowLayer() {
        const flow = ArrowLineLayer.getInstance(this.view);
        flow.clearArrowLayer();
    }

    public async showSubwayFlow() {
        const flow = SubwayLine.getInstance(this.view);
        flow.showSubwayFlow();
    }
    public async showToolTip(params: IOverlayDelete): Promise<IResult> {
        const overlay = OverlayArcgis2D.getInstance(this.view);
        return await overlay.showToolTip(params);
    }
    public async hideToolTip(params: IOverlayDelete): Promise<IResult> {
        const overlay = OverlayArcgis2D.getInstance(this.view);
        return await overlay.hideToolTip(params);
    }

    public async addOverlays(params: IOverlayParameter): Promise<IResult> {
        const overlay = OverlayArcgis2D.getInstance(this.view);
        return await overlay.addOverlays(params);
    }

    public async addOverlaysLine(params: IOverlayParameter): Promise<IResult> {
        const overlay = OverlayArcgis2D.getInstance(this.view);
        return await overlay.addOverlaysLine(params);
    }

    public async addOverlaysZHZX(params: IOverlayParameter): Promise<IResult> {
        const overlay = OverlayArcgis2DZHZXs.getInstance(this.view);
        return await overlay.addOverlays(params);
    }

    public async getOverlays(params: IOverlayDelete): Promise<IResult> {
        const overlay = OverlayArcgis2D.getInstance(this.view);
        return await overlay.getOverlays(params);
    }

    public async addOverlaysCluster(params: IOverlayClusterParameter): Promise<IResult> {
        params.bottomRight = this.bottomRight;
        params.topLeft = this.topLeft;
        const cluster = Cluster.getInstance(this.view);
        cluster.showGisDeviceInfo = this.showGisDeviceInfo;
        return await cluster.addOverlaysCluster(params);
    }

    public async deleteOverlays(params: IOverlayDelete): Promise<IResult> {
        const overlay = OverlayArcgis2D.getInstance(this.view);
        return await overlay.deleteOverlays(params);
    }
    public async deleteOverlaysLine(params: IOverlayDelete): Promise<IResult> {
        const overlay = OverlayArcgis2D.getInstance(this.view);
        return await overlay.deleteOverlaysLine(params);
    }

    public async deleteAllOverlays() {
        const overlay = OverlayArcgis2D.getInstance(this.view);
        return await overlay.deleteAllOverlays();
    }

    public async deleteOverlaysCluster(params: IOverlayDelete) {
        const cluster = Cluster.getInstance(this.view);
        return await cluster.deleteOverlaysCluster(params);
    }

    public async deleteAllOverlaysCluster() {
        const cluster = Cluster.getInstance(this.view);
        return await cluster.deleteAllOverlaysCluster();
    }

    public async findFeature(params: IFindParameter): Promise<IResult> {
        // const overlay = OverlayArcgis2D.getInstance(this.view);
        // return await overlay.findFeature(params);
        const findfeature = FindFeature.getInstance(this.view);
        return await findfeature.findLayerFeature(params);
    }
    public async findFeatureYp(params: IFindParameter): Promise<IResult> {
        // const overlay = OverlayArcgis2D.getInstance(this.view);
        // return await overlay.findFeature(params);
        const findfeature = FindFeatureYp.getInstance(this.view);
        return await findfeature.findLayerFeature(params);
    }

    private async highlightFeature(geometry?: any) {
        // const overlay = OverlayArcgis2D.getInstance(this.view);
        // return await overlay.findFeature(params);
        const findfeature = FindFeature.getInstance(this.view);
        findfeature.startHighlightOverlays(geometry);
    }

    public stopHighlightFeature(): void {
        const findFeature = FindFeature.getInstance(this.view);
        findFeature.stopHightlightFeature();
    }

    public async getMapOption(): Promise<IResult> {
        const { center, zoom, map } = this.view;
        return { message: "", status: 0, result: { center, zoom, map } };
    }

    public async showLayer(params: ILayerConfig) {
        let toggleOther = params.toggleOther === true;
        let labels: string[] = params.label ? (params.label instanceof Array ? (params.label as string[]) || [] : [params.label]) : [];
        if (labels.length == 0) {
            return;
        }
        this.view.map.allLayers.forEach((baselayer: any) => {
            if (labels.indexOf(baselayer.label) > -1) {
                if (!baselayer.visible) {
                    baselayer.visible = true;
                }
            } else {
                //其余的图层
                if (toggleOther && (baselayer.type == "feature" || baselayer.type == "map-image")) {
                    baselayer.visible = false;
                }
            }
        });
        this.imageParams.forEach((baselayer: any) => {
            if (labels.indexOf(baselayer.label) > -1) {
                if (!baselayer.visible) {
                    baselayer.visible = true;
                }
            }
        });
        const heat = ImageOverlays.getInstance(this.view);
        heat.clearCanvas();
        setTimeout(() => {
            this.imageParams.forEach((layerConfig: any) => {
                if (layerConfig.visible) heat.addCanvasImage(layerConfig);
            });
        }, 1000);
    }

    public async hideLayer(params: ILayerConfig) {
        let toggleOther = params.toggleOther === true;
        let labels: string[] = params.label ? (params.label instanceof Array ? (params.label as string[]) || [] : [params.label]) : [];
        if (labels.length == 0) {
            return;
        }

        this.view.map.allLayers.forEach((baselayer: any) => {
            if (labels.indexOf(baselayer.label) > -1) {
                if (baselayer.visible) {
                    baselayer.visible = false;
                }
            } else {
                //其余的非切片图层
                if (toggleOther && (baselayer.type == "feature" || baselayer.type == "map-image")) {
                    baselayer.visible = true;
                }
            }
        });

        this.imageParams.forEach((baselayer: any) => {
            if (labels.indexOf(baselayer.label) > -1) {
                if (baselayer.visible) {
                    baselayer.visible = false;
                }
                console.log(baselayer.label, 11111);
            }
        });
        const heat = ImageOverlays.getInstance(this.view);
        heat.clearCanvas();
        setTimeout(() => {
            this.imageParams.forEach((layerConfig: any) => {
                if (layerConfig.visible) heat.addCanvasImage(layerConfig);
            });
        }, 1000);
    }

    public toggleLayerByYear(year: string) {
        let showlabels: string[] = [];
        this.view.map.allLayers.forEach((baselayer: any) => {
            if ((baselayer.type == "feature" || baselayer.type == "map-image") && baselayer.visible) {
                if (baselayer.label) {
                    showlabels.push(baselayer.label);
                }
            }
        });
        showlabels = showlabels.map((label: string) => {
            label = label.replace("2025", year).replace("2024", year).replace("2023", year).replace("2022", year).replace("2021", year).replace("2020", year).replace("2019", year).replace("2018", year);
            return label;
        });
        this.showLayer({ label: showlabels, toggleOther: true });
    }

    public async setMapCenter(params: IPointGeometry) {
        let x = params.x;
        let y = params.y;
        let duration = params.duration || 1;
        if (!isNaN(x) && !isNaN(y)) {
            if (!this.view.spatialReference.isWGS84 && !this.view.spatialReference.isWebMercator) {
                //城建坐标
                this.view.goTo(
                    {
                        center: { x, y, spatialReference: this.view.spatialReference },
                    },
                    {
                        duration: duration * 1000, //视角跳转时长为2秒，
                    }
                );
            } else {
                this.view.goTo(
                    {
                        center: [x, y],
                    },
                    {
                        duration: duration * 1000, //视角跳转时长为2秒，
                    }
                );
            }
        }
    }

    public setMapViewpoint(viewpoint: __esri.Viewpoint) {
        this.view.viewpoint = viewpoint;
    }
    //新增指挥中心2000坐标定位
    public async setMapCenterAndLevelZHZX(params: ICenterLevel) {
        let _this = this;
        let x = params.x || this.view.center.x;
        let y = params.y || this.view.center.y;
        let level: number = params.level || this.view.zoom;
        let Ponit2000 = new this.Point({
            x,
            y,
            spatialReference: { wkid: 3857 },
        });
        _this.view.goTo({
            center: Ponit2000,
            zoom: level,
        });
    }

    public async setMapCenterAndLevel(params: ICenterLevel) {
        let x = params.x || this.view.center.x;
        let y = params.y || this.view.center.y;
        let level: number = params.level || this.view.zoom;
        let duration = params.duration || 1;
        if (!isNaN(x) && !isNaN(y) && !isNaN(level) && level >= 0) {
            if (!this.view.spatialReference.isWGS84 && !this.view.spatialReference.isWebMercator) {
                //城建坐标
                this.view.goTo(
                    {
                        center: { x, y, spatialReference: this.view.spatialReference },
                        zoom: level,
                    },
                    {
                        duration: duration * 1000,
                    }
                );
            } else {
                this.view.goTo(
                    {
                        center: [x, y],
                        zoom: level,
                    },
                    {
                        duration: duration * 1000,
                    }
                );
            }
        }
    }

    public async setMapLevel(params: IMapLevel): Promise<void> {
        const animate = params.animate === true;
        const level = params.level;
        const factor = params.factor;
        let duration = params.duration || 1;
        if (level) {
            if (animate) {
                await this.view.goTo(
                    { zoom: level },
                    {
                        duration: duration * 1000,
                    }
                );
            } else {
                this.view.zoom = level;
            }
        } else if (factor) {
            if (animate) {
                await this.view.goTo(
                    { zoom: this.view.zoom + factor },
                    {
                        duration: duration * 1000,
                    }
                );
            }
            this.view.zoom += factor;
        }
    }

    public moveLayerToTop(params: { type: string }): IResult {
        const type = params.type;
        if (type) {
            const findlayer = this.view.map.allLayers.find((layer: any): boolean => {
                const _t = layer.label || layer.title;
                return _t == type;
            });
            this.view.map.reorder(findlayer, this.view.map.allLayers.length);
        }
        return {
            status: 0,
            message: `move success`,
        };
    }

    public reorderLayer(params: { type: string; order: number }): IResult {
        const type = params.type;
        const order = params.order;
        if (type) {
            const findlayer = this.view.map.allLayers.find((layer: any): boolean => {
                const _t = layer.label || layer.title;
                return _t == type;
            });
            this.view.map.reorder(findlayer, order);
        }
        return {
            status: 0,
            message: `reorder success`,
        };
    }

    public getMapLevel(): number {
        return this.view.zoom;
    }

    public async measure_length(): Promise<IResult> {
        const measurement = MeasureModel_ArcGIS.getInstance(this.view);
        return await measurement.measure_length();
    }

    public async measure_area(): Promise<IResult> {
        const measurement = MeasureModel_ArcGIS.getInstance(this.view);
        return await measurement.measure_area();
    }

    public measure_clear() {
        const measurement = MeasureModel_ArcGIS.getInstance(this.view);
        measurement.measure_clear();
    }

    public async showRoad() {}
    public async hideRoad() {}
    public async showStreet() {}
    public async hideStreet() {}
    public async locateStreet(param: IStreetParameter) {}

    public async addHeatMap(params: IHeatParameter): Promise<IResult> {
        const heatmap = HeatMap.getInstance(this.view);
        return await heatmap.addHeatMap(params);
    }
    public async addHeatMapFromServer(params: IHeatMapParams): Promise<IResult> {
        const heatmap = HeatMap.getInstance(this.view);
        return heatmap.addHeatMapFromServer(params);
    }
    public async deleteHeatMap(params: ILayerConfig) {
        const heatmap = HeatMap.getInstance(this.view);
        return await heatmap.deleteHeatMap(params);
    }

    public setMapStyle(param: string) {}

    public async routeSearch(params: IRouteParameter): Promise<IResult> {
        return { status: -1, message: "no function" };
    }
    public clearRouteSearch() {}
    public showRoutePoint(params: any) {}
    public clearRoutePoint() {}
    public async searchShortestPath(params: IRouteParameter): Promise<IResult> {
        let route = Route.getInstance(this.view);
        return route.searchShortestPath(params);
    }
    public async clearShortestPath(): Promise<IResult> {
        let route = Route.getInstance(this.view);
        return route.clearShortestPath();
    }
    public async addDrawLayer(params: any): Promise<IResult> {
        const drawlayer = DrawLayer.getInstance(this.view);
        return await drawlayer.addDrawLayer(params);
    }
    public clearDrawLayer(params: any) {
        const drawlayer = DrawLayer.getInstance(this.view);
        drawlayer.clearDrawLayer(params);
    }
    //接口内部使用,点击点位,需要配置showMigrate
    public async showODChart(params: any) {
        const chart = MigrateChart.getInstance(this.view);
        chart.showODChartByLayer(params);
    }
    //开发接口,传入数据
    public async showODData(params: any) {
        if (params.custom) {
            const chart = MigrateChartCom.getInstance(this.view);
            this.showSubOD = true;
            chart.showODChartByData(params);
        } else {
            console.log("od线吗，老铁1");
            const chart = MigrateChart.getInstance(this.view);
            this.showSubOD = true;
            chart.showODChartByData(params);
        }
    }
    public async showSubwayMigrateChart(params: any) {
        const chart = MigrateChart.getInstance(this.view);
        chart.showSubwayMigrateChart(params);
    }
    public showMigrateChart(params: any) {
        const chart = MigrateChart.getInstance(this.view);
        chart.showPathChart(params);
    }
    public hideMigrateChart(params?: { custom: boolean }) {
        if (params?.custom) {
            const chart = MigrateChartCom.getInstance(this.view);
            chart.hideMigrateChart();
        } else {
            const chart = MigrateChart.getInstance(this.view);
            chart.hideMigrateChart();
        }
    }
    public showBarChart(params: any) {
        const chart = Bar3DChart.getInstance(this.view);
        chart.showBarChart(params);
    }
    public hideBarChart() {
        const chart = Bar3DChart.getInstance(this.view);
        chart.hideBarChart();
    }
    public addHeatImage(params: IHeatImageParameter) {
        const heat = HeatImageGL.getInstance(this.view);
        heat.addHeatImage(params);
    }
    public deleteHeatImage() {
        const heat = HeatImageGL.getInstance(this.view);
        heat.deleteHeatImage();
    }
    public async startGeometrySearch(params: IGeometrySearchParameter): Promise<IResult> {
        let geometrySearch = GeometrySearch.getInstance(this.view);
        return await geometrySearch.startGeometrySearch(params);
    }
    public clearGeometrySearch() {
        let geometrySearch = GeometrySearch.getInstance(this.view);
        geometrySearch.clearGeometrySearch();
    }
    // public async addDgeneFusion(params: any): Promise<IResult> {
    //   const dgene = DgeneFusion.getInstance(this.view);
    //   return await dgene.addDgeneFusion(params);
    // }
    // public async restoreDegeneFsion(): Promise<IResult> {
    //   const dgene = DgeneFusion.getInstance(this.view);
    //   return await dgene.restoreDegeneFsion();
    // }
    // public async showDgene(params: any): Promise<IResult> {
    //   let dgene = DgeneFusion.getInstance(this.view);
    //   return await dgene.showDgene(params);
    // }
    // public hideDgene() {
    //   let dgene = DgeneFusion.getInstance(this.view);
    //   dgene.hideDgene();
    // }
    public showCustomTip(params: ICustomTip) {
        let className: string = params ? params.class || "custom-popup" : "custom-popup";
        if (params == undefined || (params && params.clear !== false)) {
            ToolTip.clear(this.view, undefined, className);
        }
        if (params && params.geometry) {
            params.prop.className = className;
            params.prop.bubble = params.bubble !== false;
            let ctip = new ToolTip(this.view, params.prop, params.geometry);
        }
    }
    public closePopup() {
        this.view.popup.close();
    }

    public async showPopup(params: IPopUpTemplate) {
        if (!this.clickPopup) {
            return;
        }
        let popup = this.clickPopup.popup;
        let graphic = this.clickPopup.graphic;
        let mp = this.clickPopup.mapPoint;
        let attrs = Utils.copyObject(graphic.attributes);

        for (let field in attrs) {
            let fieldArr: string[] = field.toString().split(".");
            let newfield = fieldArr.pop() as string;
            if (!attrs.hasOwnProperty(newfield)) {
                attrs[newfield] = attrs[field] !== undefined && attrs[field] !== null ? attrs[field].toString().replace("Null", "") : "";
            }
        }

        for (let str in params.fields) {
            //if (!attrs.hasOwnProperty(str)) {
            attrs[str] = params.fields[str];
            //}
        }
        if (popup) {
            this.view.popup.open({
                title: popup.title,
                content: this.getContent(attrs, popup.content),
                location: mp,
            });
        }
    }
    // public showDgeneOutPoint(params: any) {
    //   let dgene = DgeneFusion.getInstance(this.view);
    //   dgene.showDgeneOutPoint(params);
    // }
    // public changeDgeneOut() {
    //   let dgene = DgeneFusion.getInstance(this.view);
    //   dgene.changeDgeneOut();
    // }

    /** 初始化特勤线路基础数据，并进入路段选择状态 */
    public async initializeRouteData(params: ISelectRouteParam) {
        const selectRoute = SelectRoute2D.getInstance(this.view);
        selectRoute.selectRouteFinished = this.selectRouteFinished;
        await selectRoute.initializeRoute(params);
    }

    public async showSelectedRoute(params: ISelectRouteResult) {
        const selectRoute = SelectRoute2D.getInstance(this.view);
        await selectRoute.showSelectedRoute(params);
    }

    public async playSelectedRoute(speed: number) {
        const selectRoute = SelectRoute2D.getInstance(this.view);
        selectRoute.intoSignal = this.intoSignal;
        selectRoute.outofSignal = this.outofSignal;
        await selectRoute.playSelectedRoute(speed);
    }

    public stopPlaySelectedRoute() {
        const selectRoute = SelectRoute2D.getInstance(this.view);
        selectRoute.stopPlaySelectedRoute();
    }

    public async routeHitArea(params: ISelectRouteHitTest): Promise<IResult> {
        const selectRoute = SelectRoute2D.getInstance(this.view);
        return await selectRoute.routeHitArea(params);
    }

    public async areaHitRoute(params: ISelectRouteHitTest) {
        const selectRoute = SelectRoute2D.getInstance(this.view);
        return await selectRoute.areaHitRoute(params);
    }

    public async startDrawOverlays(params: IDrawOverlays): Promise<void> {
        const drawoverlay = DrawOverlays.getInstance(this.view);
        return await drawoverlay.startDrawOverlays(params);
    }
    public async stopDrawOverlays(): Promise<void> {
        const drawoverlay = DrawOverlays.getInstance(this.view);
        return await drawoverlay.stopDrawOverlays();
    }
    public async deleteDrawOverlays(params: IOverlayDelete): Promise<void> {
        const drawoverlay = DrawOverlays.getInstance(this.view);
        return await drawoverlay.deleteDrawOverlays(params);
    }
    public async getDrawOverlays(): Promise<IResult> {
        const drawoverlay = DrawOverlays.getInstance(this.view);
        return await drawoverlay.getDrawOverlays();
    }
    public async startLayerSearch(params: IGeometrySearchParameter): Promise<IResult> {
        const layersearch = LayerSearch.getInstance(this.view);
        return await layersearch.startLayerSearch(params);
    }
    public async startLayerDefinition(params: IDefinitionParameter): Promise<void> {
        const definition = LayerDefinition.getInstance(this.view);
        return await definition.startLayerDefinition(params);
    }
    public async startTrackPlay(params: ITrackParameter): Promise<void> {
        const track = TrackPlay.getInstance(this.view);
        track.startTrackPlay(params);
    }
    public stopTrackPlay() {
        const track = TrackPlay.getInstance(this.view);
        track.stopTrackPlay();
    }
    public async getRegionOverlays(params: IOverlayParameter): Promise<IResult> {
        const overlay = OverlayArcgis2D.getInstance(this.view);
        return await overlay.getRegionOverlays(params);
    }

    public startWatchMapCenter() {
        const mapCenterCheck = MapCenterCheck.getInstance(this.view);
        mapCenterCheck.mapInteractive = this.mapInteractive;
        mapCenterCheck.startWatchMapCenter();
    }

    public stopWatchMapCenter() {
        const mapCenterCheck = MapCenterCheck.getInstance(this.view);
        mapCenterCheck.stopWatchMapCenter();
    }

    public async addAnimatePoints(params: IOverlayParameter): Promise<IResult> {
        return { status: -2, message: "no function" };
    }

    public async deleteAnimatePoints(params?: IOverlayDelete): Promise<IResult> {
        return { status: -2, message: "no function" };
    }

    public async addAnimateLines(params: IAnimateLineAddParams): Promise<IResult> {
        const animateLine = AnimateLine.getInstance(this.view);
        return animateLine.addOne(params);
    }

    public async deleteAnimateLines(params: IAnimateLineDelParams): Promise<IResult> {
        const animateLine = AnimateLine.getInstance(this.view);
        return animateLine.delete(params);
    }

    public async startSignalPhase(params: ISignalPhaseInfo): Promise<IResult> {
        return { status: -2, message: "no function" };
    }

    public async connectSumoSimulation(params: ISumoConnectInfo): Promise<IResult> {
        const similationController = SimulationController.getInstance(this.view);
        return similationController.connectSumoSimulation(params);
    }

    public disconnectSumoSimulation() {
        const similationController = SimulationController.getInstance(this.view);
        similationController.disconnectSumoSimulation();
    }

    public async connectRealTimeSimulation(params: ISumoConnectInfo): Promise<IResult> {
        const similationController = SimulationController.getInstance(this.view);
        return similationController.connectRealTimeSimulation(params);
    }

    public disconnectRealTimeSimulation() {
        const similationController = SimulationController.getInstance(this.view);
        similationController.disconnectRealTimeSimulation();
    }

    public focusOnVehicle(id: string) {
        const similationController = SimulationController.getInstance(this.view);
        similationController.focusOnVehicle(id);
    }

    public cancelFocusOnVehicle() {
        const similationController = SimulationController.getInstance(this.view);
        similationController.cancelFocus();
    }

    public async addQueryIntersect(params: IQueryParameter) {
        const query = QueryIntersect.getInstance(this.view);
        query.addQueryIntersect(params);
    }

    public async deleteQueryIntersect(params: string | undefined) {
        const query = QueryIntersect.getInstance(this.view);
        query.deleteQueryIntersect(params);
    }

    public async route_initialize(params?: { signalUrl?: string; cameraUrl?: string; crossUrl?: string; token?: string; showRoad?: boolean }) {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        await direction.initialize(params);

        const direction_colllinear = DirectionModel_Collinear.getInstance(this.view);
        await direction_colllinear.initialize(params);
    }

    public async route_addStartPoint(): Promise<IResult> {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        const pointResult = await direction.getPoint("start");
        return { status: 0, message: "", result: pointResult };
    }

    public async route_addEndPoint(): Promise<IResult> {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        const pointResult = await direction.getPoint("end");
        return { status: 0, message: "", result: pointResult };
    }

    public async route_addWayPoint(index: number): Promise<IResult> {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        const pointResult = await direction.getPoint("way", index);
        return { status: 0, message: "", result: pointResult };
    }

    public route_deleteWayPoint(index: number): IResult {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        return direction.deleteWayPoint(index);
    }

    public async route_getRoute(): Promise<IResult> {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        return await direction.makeRoute();
    }

    public async route_getMultiRoutes(params: IMultiStartRoute): Promise<IResult> {
        const direction = DirectionModel_Collinear.getInstance(this.view);
        return await direction.getMultiRoutes(params);
    }

    public async route_showRoute(params: { strategy?: string; coordinates?: string; signalIds?: string[] }): Promise<IResult> {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        return await direction.showRoute(params);
    }

    public async route_clearRoutes() {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        await direction.clearRoutes();

        const direction_colllinear = DirectionModel_Collinear.getInstance(this.view);
        await direction_colllinear.clearRoutes();
    }

    public route_focusCross(crossId: string): Promise<IResult> {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        return direction.focusCross(crossId);
    }

    public route_play(speed: number) {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        direction.intoSignal = this.intoSignal;
        direction.outofSignal = this.outofSignal;
        direction.play(speed);
    }

    public route_stop() {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        direction.stop();
    }

    public route_pause() {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        direction.pause();
    }

    public route_resume() {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        direction.resume();
    }

    public async route_routeHitArea(params: IRouteHitTestParam): Promise<IResult> {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        return await direction.routeHitArea(params);
    }

    public async route_areaHitRoute(params: IRouteHitTestParam): Promise<IResult> {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        return await direction.areaHitRoute(params);
    }

    public route_showHitResult(params: IRouteHitTestResultParam) {
        const direction = DirectionModel_ArcGIS.getInstance(this.view);
        direction.showHitResult(params);
    }

    public initializeLaneSignalPhase(crossId: string) {
        const signalPhaseController = SignalPhaseController2D.getInstance(this.view);
        signalPhaseController.initializeCross(crossId);
    }

    public startLaneSignalPhase(laneSignalPhaseInfos: ILaneSignalPhaseInfo[]) {
        const signalPhaseController = SignalPhaseController2D.getInstance(this.view);
        signalPhaseController.startLaneSignalPhase(laneSignalPhaseInfos);
    }

    public test() {}

    public async startTrackLine(params: ITrackLineParameter): Promise<IResult> {
        const track = TrackLine.getInstance(this.view);
        return await track.startTrackLine(params);
    }

    public stopTrackLine() {
        const track = TrackLine.getInstance(this.view);
        track.stopTrackLine();
    }

    public async showCrossTrack(crosses: Array<ITrackCross>) {
        const trackInCross = TrackInCross.getInstance(this.view);
        trackInCross.showCrossTrack(crosses);
    }

    public hideCrossTrack() {
        const trackInCross = TrackInCross.getInstance(this.view);
        trackInCross.hideCrossTrack();
    }

    public showCrossTrackHighlight(crossId: string) {
        const trackInCross = TrackInCross.getInstance(this.view);
        trackInCross.highlightCross(crossId);
    }

    public queryCrossInView(params: ICrossInView): IResult {
        const crossInfos: Array<{
            id: string;
            name: string;
            position: number[];
        }> = [];

        const extent = this.view.extent;
        checkPoints.forEach(checkPoint => {
            const crossPoint = new this.Point({
                x: checkPoint.position[0],
                y: checkPoint.position[1],
            });
            if (extent.intersects(crossPoint)) {
                crossInfos.push({
                    id: checkPoint.id,
                    name: checkPoint.name,
                    position: checkPoint.position,
                });
            }
        });

        return { status: 0, message: "", result: crossInfos };
    }
    public async showWidgetTools(view: __esri.MapView, params: Array<IWidget>) {
        const tool = WidgetsManager.getInstance(view);
        await tool.initWidgets(params);
    }
    public toggleWidget(params: string[]) {
        const tool = WidgetsManager.getInstance(this.view);
        tool.toggleWidget(params);
    }
    public setWidgetPos(params: Array<IWidget>) {
        const tool = WidgetsManager.getInstance(this.view);
        tool.setWidgetPos(params);
    }

    public async dynamicLayer_initialize(configFile: string) {
        const dynamicLayer = DynamicIssuesect.getInstance(this.view);
        await dynamicLayer.initialize(configFile);
    }

    public async dynamicLayer_show(params: IDynamicLayerDataParams): Promise<void> {
        const dynamicLayer = DynamicIssuesect.getInstance(this.view);
        dynamicLayer.showDynamicRendererLayer(params);
    }

    public dynamicLayer_hide(params: IDynamicLayerDataParams): void {
        const dynamicLayer = DynamicIssuesect.getInstance(this.view);
        dynamicLayer.hideDynamicRendererLayer(params);
    }

    public async jsonLayer_add(params: ILayerConfig): Promise<void> {
        const drawlayer = DrawLayer.getInstance(this.view);
        drawlayer.addDrawLayer(params);
    }

    public toScreen(params: { x: number; y: number }): IResult {
        const point = new this.Point(params);
        const screenPoint = this.view.toScreen(point);
        return { status: 0, result: screenPoint, message: "success" };
    }

    public toMap(params: { x: number; y: number }): IResult {
        const point = this.view.toMap(params);
        return {
            status: 0,
            result: { x: point.longitude, y: point.latitude },
            message: "success",
        };
    }

    private imageParams: Array<any> = [];
    public showImage() {
        const heat = ImageOverlays.getInstance(this.view);
        this.imageParams.forEach((layerConfig: any) => {
            heat.addCanvasImage(layerConfig);
        });
    }

    public async addComponentOverlay(params: IComponentOverlayParam): Promise<IResult> {
        const componentOverlay = ComponentOverlay.getInstance(this.view);
        return await componentOverlay.addComponentOverlay(params);
    }

    public deleteComponentOverlay(params?: IOverlayDelete): IResult {
        const componentOverlay = ComponentOverlay.getInstance(this.view);
        return componentOverlay.deleteComponentOverlay(params);
    }

    public clearAllComponentOverlay(): IResult {
        const componentOverlay = ComponentOverlay.getInstance(this.view);
        return componentOverlay.clearAll();
    }

    public async addCustomComponentOverlay(params: IComponentOverlayParam): Promise<IResult> {
        const componentOverlay = ComponentOverlay.getInstance(this.view);
        return await componentOverlay.addCustomComponentOverlay(params);
    }

    public async setMapControl(params: IMapControlParam) {
        let instance: any;
        switch (params.type) {
            case "scale":
                //拿到实例
                instance = ScaleBarArc2D.getInstance(this.view);
                break;
            case "zoom":
                //拿到实例
                instance = ZoomArc2D.getInstance(this.view, params.options);
                break;
            default:
                return;
        }
        instance.set(params);
    }
}
